import * as L from "leaflet";
import MapHelper from "../helpers/MapHelper";
import ProjectsRequests from "../requests/ProjectsRequests";
import _ from 'lodash';


export default class MarksModel {
    static MAX_SHAPE_DIAMETER = 50000; // in meters

    projectsRequests = null;
    dryMarks = {};
    invalidMarks = [];

    bounds = null;
    boundsValid = false;

    constructor(projectsRequests: ProjectsRequests) {
        this.projectsRequests = projectsRequests;
    }


    update(marks) {
        const dryingResults = MarksModel.dryMarks(marks);
        if (
            _.isEqual(dryingResults.dryMarks, this.dryMarks) &&
            _.isEqual(dryingResults.invalidMarks, this.invalidMarks)
        ) {
            return;
        }

        this.dryMarks = dryingResults.dryMarks;
        this.invalidMarks = dryingResults.invalidMarks;

        // build bounds for all marks together
        this.bounds = null;
        Object.keys(this.dryMarks).forEach((markId) => {
            const mark = this.dryMarks[markId];
            if (mark.bounds) {
                if (this.bounds === null) {
                    this.bounds = L.latLngBounds(mark.bounds._northEast, mark.bounds._southWest);
                }
                this.bounds = L.latLngBounds(this.bounds).extend([mark.bounds._northEast, mark.bounds._southWest]);
            }
        });
        this.boundsValid = this.bounds && (typeof this.bounds === 'object') && this.bounds.isValid();
    }


    static validateMark = (mark) => {
        const realGeoJSON = mark.shadowGeoJSON || mark.geoJSON;
        if (!(realGeoJSON && realGeoJSON.geometry && realGeoJSON.geometry.coordinates)) {return false;}

        let markBounds;
        try {
            markBounds = L.geoJSON(realGeoJSON).getBounds();
        } catch (error) {
            return false;
        }

        return markBounds.isValid();
    }


    static _dryMark = (mark) => {
        if (!MarksModel.validateMark(mark)) {return;}

        return {
            id: mark.id,
            type: mark.type,
            geoJSON: mark.geoJSON,
            shadowGeoJSON: mark.shadowGeoJSON,
            layerData: mark.layerData,
            bounds: mark.bounds
        };
    }


    static dryMarks = (marks) => {
        if (!marks) {
            return {
                dryMarks: {},
                invalidMarks: []
            };
        }

        if (typeof marks === 'object') {
            marks = Object.values(marks);
        }

        let dryMarks = {}, dryMarkTmp,
            invalidMarks = [];
        if (marks.length) {
            marks.forEach((mark) => {
                const realGeoJSON = mark.shadowGeoJSON || mark.geoJSON;
                //console.log('validateMark', mark.id, realGeoJSON);

                dryMarkTmp = MarksModel._dryMark(mark);
                if (dryMarkTmp) {
                    dryMarks[mark.id] = dryMarkTmp;
                } else {
                    invalidMarks.push(mark);
                }
            });
        }

        return {
            dryMarks: dryMarks,
            invalidMarks: invalidMarks
        };
    }


    getDataForProjectUpdate = () => {
        const packedData = {
            marks: this.dryMarks,
            bounds: this.bounds,
        };

        return JSON.parse(JSON.stringify(packedData));
    }


    getMergedDataForProjectUpdate = (shapesDataForProjectUpdate) => {
        let marks = this.getDataForProjectUpdate(),
            newBounds = null;

        // extend bounds
        if (marks.bounds && shapesDataForProjectUpdate.bounds) {
            newBounds = L.latLngBounds(marks.bounds._northEast, marks.bounds._southWest);
            newBounds = L.latLngBounds(newBounds).extend([shapesDataForProjectUpdate.bounds._northEast, shapesDataForProjectUpdate.bounds._southWest]);
        } else if (marks.bounds) {
            newBounds = marks.bounds;
        } else if (shapesDataForProjectUpdate.bounds) {
            newBounds = shapesDataForProjectUpdate.bounds;
        }

        let results = {... shapesDataForProjectUpdate};
        results.marks = marks.marks;
        results.bounds = newBounds;

        return results;
    }
}